module.exports = __webpack_public_path__ + "img/popup_button_normal.b248a5d0.png";